import axios from "axios";
import WriteToLog from "./WriteToLog";

/**
 * Get Flowsheet Row value from EHR for the given encoded FLO ID
 * @param {*} patFHIRID 
 * @param {*} encodedFloID 
 * @param {*} codeText 
 * @param {*} fhir_server 
 * @param {*} access_token 
 * @returns 
 */
async function getObservationFlowsheetWithin7Days(patFHIRID, encodedFloID, codeText, fhir_server, access_token) {
  if (encodedFloID) {
    //var category = "vital-signs";
    const floObj = {};
    let errorCode = "";
    const floValue = {};

    var date = new Date();
    date.setHours(date.getHours() - 168);
    //console.log("date - 168 hours (7 days): " + date);
    const isoStringWithoutMs = date.toISOString().slice(0, 19) + 'Z';

    var date2 = new Date();
    date2.setHours(date2.getHours() - 1);
    const isoStringWithoutMs2 = date2.toISOString().slice(0, 19) + 'Z';

    const ehrconfig = await axios.get('ehrconfig.json');
    let observationSearchUrl = ehrconfig.data["EHR_OBSERVATION_SEARCH_R4"];
    let getObservationFlowsheetUrl = fhir_server + observationSearchUrl + '?code=' + encodedFloID + '&patient=' + patFHIRID + '&date=ge' + isoStringWithoutMs + '&date=le' + isoStringWithoutMs2;

    try {
      let response = await axios.get(
        getObservationFlowsheetUrl,
        {
          headers:
          {
            'Authorization': 'Bearer ' + access_token,
            'Accept': 'application/json'
          }
        });
      WriteToLog("getObservationFlowsheetWithin7Days Observation.Search (R4) FHIR response: " + JSON.stringify(response.data));
      if (response.data.total > 0) {
        let entryArray = response.data.entry;
        // Get the latest value from the top entryArray[0]
        if (entryArray.length > 0) {
          if (entryArray[0].resource !== undefined) {
            let resourceType = entryArray[0].resource.resourceType;
            //console.log("Resource Type: " + resourceType);
            if (resourceType === "Observation" && entryArray[0].resource.code !== undefined) {
              //let code = entryArray[0].resource.code.text;
              //console.log("Code: " + code);
              //console.log("issued: " + entryArray[0].resource.issued);
              if (entryArray[0].resource.valueQuantity !== undefined) {
                floValue.value = entryArray[0].resource.valueQuantity.value;
                floValue.unit = entryArray[0].resource.valueQuantity.unit;
                floValue.timestamp = entryArray[0].resource.issued;
                //floValue = entryArray[0].resource.valueQuantity.value + "" + entryArray[0].resource.valueQuantity.unit;
                //console.log("floValue1: " + JSON.stringify(floValue));
              }
              if (entryArray[0].resource.valueCodeableConcept !== undefined) {
                floValue.value = entryArray[0].resource.valueCodeableConcept.text;
                //console.log("floValue: " + floValue);
              }
            }
          }
        }
        floObj[codeText] = floValue;
        //WriteToLog("getObservationFlowsheetWithin7Days Observation.Search (R4) response for " +  codeText + ": " + JSON.stringify(floValue));
        return floObj;
      } else {
        //ehr value empty if total is 0
        let entryArray = response.data.entry;
        for (var j = 0; j < entryArray.length; j++) {
          if (entryArray[j].resource !== undefined) {
            let resourceType = entryArray[j].resource.resourceType;
            if (resourceType === "OperationOutcome" && entryArray[j].resource.issue !== undefined) {
              let issueArray = entryArray[j].resource.issue;
              if (issueArray.length > 0) {
                if (entryArray[j].resource.issue[0].diagnostics !== undefined)
                {
                  errorCode = "Error: " + entryArray[j].resource.issue[0].diagnostics;
                } else {
                  errorCode = entryArray[j].resource.issue[0].details.text;
                }
              }
            }
          }
        }
        return errorCode;
      }
    } catch (error) {
      WriteToLog("getObservationFlowsheetWithin7Days Observation.Search FHIR error: " + error.message);
      return null; 
    }
  }
}

export default getObservationFlowsheetWithin7Days;
